import { InstructionType, InstructionTypeType } from 'types/InstructionType'

export const ChooseOneInstructionTypeKeys = new Set<InstructionTypeType>([
  InstructionType.ORGANIZATION,
  InstructionType.BILLING_PRIMARY,
])